var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup",class:{ popup__small: _vm.size === 'small' }},[(_vm.title)?_c('div',{staticClass:"popup__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('div',{staticClass:"popup__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }